

import React, { useState, useEffect } from "react";
import Menu from '../common/Menu';
import MenuItems, { filterMenuItemsByPermissions } from './MenuItems';
import Topbar from './Topbar';
import { AuthContext } from './App';
import { usePermissions } from '../common/hooks/usePermissions';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import { Helmet } from 'react-helmet-async';
import './PrivateHome.css';

const useAuth = () => {
    return React.useContext(AuthContext);
}

export const PrivateHome = ({children, user, config}) => {
    const username = user ? user.name : '';
    const [menuOpen, setMenuOpen] = useState(false);
    const [isMobile, setIsMobile] = useState(false);
    const { permissions, loading } = usePermissions();
    
    // Detect mobile view
    useEffect(() => {
        const checkMobile = () => {
            setIsMobile(window.innerWidth < 768);
        };
        
        checkMobile();
        window.addEventListener('resize', checkMobile);
        
        return () => window.removeEventListener('resize', checkMobile);
    }, []);
    
    const handleMenuToggle = () => {
        setMenuOpen(!menuOpen);
    }
    const handleMenuclosed = () => {
        setMenuOpen(false);
    }

    const { onLogout } = useAuth();

    // Filter menu items based on user permissions
    const filteredMenuItems = loading ? [] : filterMenuItemsByPermissions(MenuItems, permissions);

    return (
            <div className="page-container">
                <Helmet>
                    <title>{config.app?.name}</title>
                    <link rel="icon shortcut" href={config.app?.favicon} />
                </Helmet>
                {/* Mobile hamburger menu button - only render on mobile */}
                {isMobile && (
                    <div className="mobile-menu-toggle d-md-none">
                        <button 
                            className="btn btn-link text-dark p-2"
                            onClick={handleMenuToggle}
                            aria-label="Toggle menu"
                        >
                            {menuOpen ? <CloseIcon /> : <MenuIcon />}
                        </button>
                    </div>
                )}

                {/* Overlay for mobile menu - positioned before sidebar */}
                {menuOpen && (
                    <div 
                        className="sidebar-overlay d-md-none" 
                        onClick={handleMenuclosed}
                    ></div>
                )}

                {/* Sidebar with mobile responsiveness */}
                <div className={`sidebar-menu ${menuOpen ? 'sidebar-open' : 'sidebar-closed'}`}>
                    <div className="sidebar-menu-inner">
                        <header className="logo-env">
                            <div className="logo-image">
                                <img src={config.app?.logo} alt="Logo" height="40" />
                            </div>
                            <div className="logo-text">{config.app?.name}</div>
                        </header>
                        <ul id="main-menu" className="main-menu">
                            {loading ? (
                                <li className="p-4 text-center text-gray-500">Loading menu...</li>
                            ) : (
                                <Menu items={filteredMenuItems}/>
                            )}
                        </ul>
                    </div>
                </div>

                <div className="main-content" style={{flex: 1}}>
                    <Topbar onLogout={onLogout} user={user}/>
                    <div className="row">
                        <div className="col-md-12">
                            {children}
                        </div>
                    </div>  
                </div>  
            </div>
    );
}